export default "__VITE_ASSET__GkOixEQV__"